import { validationMapper } from './validation_mapper'

export const getValidationMethod = (requiredType, type, formElement, validationTexts, publicFileInfo) => (value) => validationMapper(requiredType, type, formElement)(value, formElement, validationTexts, publicFileInfo)
